import MainSis from '@/modules/layout/main.vue'
import Login from '@/modules/layout/login/main.vue'
import LoginRelatorioPrevencaoVisualizar from '@/modules/layout/login/relatorio-prevencao-visualizar.vue'
import loadView from './helpers/loadView'
const RecuperarSenha = 'modules/externo/recuperar-senha/main'
const validarDocumento = 'modules/externo/validar-documento/main'
const SuprimentoRecebimento = 'modules/externo/suprimento-recebimento/main'

export default [
	{
		path: '/load',
		component: MainSis,
		name: 'load'
	},
	{
		path: '/login',
		component: Login,
		name: 'login',
		props: true
	},
	{
		path: '/login/relatorio-prevencao-visualizar',
		component: LoginRelatorioPrevencaoVisualizar,
		name: 'login-relatorio-prevencao-visualizar',
		props: true,
		beforeEnter(to, from, next) {
			if (!Number(to.params.id)) next({name: 'login'})
			next()
		}
	},
	{
		path: '/reseta-senha/:email/:id/:hash/:login',
		name: 'reseta-senha',
		component: loadView(RecuperarSenha),
		props: true
	},
	{
		path: '/valida-documento/:hash?',
		name: 'valida-documento',
		component: loadView(validarDocumento),
		props: true
	},
	{
		path: '/suprimento-recebimento',
		name: 'suprimento-recebimento',
		component: loadView(SuprimentoRecebimento),
		props: true
	}
]
